import React from "react";

import Aux from "../AuxFunctions";
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";

class PageNotFound extends React.Component {

    goBack = () => {
        try {
            this.props.history.goBack()
        } catch (error) {
            Aux.handleError(error)
        }
    }

    render() {

        return (
            <div style={{width:"100%"}}>
                <section className="container">

                    <div className="reversed-button-hover" style={{display:"flex", alignItems:"center",}} onClick={this.goBack}>
                        <ChevronLeftIcon style={{marginRight:5}}></ChevronLeftIcon>
                        <h4>Go back</h4>
                    </div>

                    <div style={{marginTop:30, display:"flex", justifyContent:"center"}}>
                        <h3 style={{color:"#333"}}>
                            Page Not Found.
                        </h3>
                        {/* <div>
                            <span>try another one</span>
                        </div> */}
                    </div>
                </section>
            </div>
        );
    }
}

export default PageNotFound;